// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

const xAddressesStyle: {
    wrapper?: InjectableCss;
    headingText: TypographyProps;
    companyNameText: TypographyProps;
    addressText: TypographyProps;
    addressCity: TypographyProps;
    addressCountry: TypographyProps;
    addressPhone: TypographyProps;
} = {
    wrapper: {
        css: css`
            font-style: normal;
            @media print {
                &&{
                padding-top: 0;
                }
            }
        `,
    },
    headingText: {
        variant: "h5",
    },
    companyNameText: {
        as: "p",
        size: 16,
        weight: "bold",
        lineHeight: "22px",
        css: css`
            margin-bottom: 12px;
            @media print {
                font-size: 11px;
                margin-bottom: 0;
            }
        `,
    },
    addressText: {
        as: "p",
        size: 15,
        lineHeight: "26px",
    },
    addressCity: {
        as: "span",
        size: 15,
        lineHeight: "26px",
    },
    addressCountry: {
        as: "span",
        size: 15,
        lineHeight: "26px",
        css: css`
            padding-left: 5px;
            margin-bottom: 30px;
        `,
    },
    addressPhone: {
        as: "p",
        size: 15,
        lineHeight: "26px",
        css: css`
            margin-top: 20px;
        `,
    },
};

export { xAddressesStyle };
